module.exports = __webpack_public_path__ + "Icono_Encuestra_512.png";